import { X } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

import { assistantText } from './assistantText'
import { useAssistant } from './AssistantProvider'

interface ReviewBannerProps {
  /** 'save' for forms (the page's own Save commits); 'publish' for the theme editor. */
  mode: 'save' | 'publish'
  /** Omitted where the screen has its own discard (the theme editor). */
  onDiscard?: () => void
  className?: string
}

/** Shown above a screen opened by the assistant with a prepared change: the merchant checks, then saves. */
export const ReviewBanner = ({ mode, onDiscard, className }: ReviewBannerProps) => {
  const { language } = useAssistant()
  const t = assistantText(language)
  return (
    <div data-assistant-review className={cn('assistant-fade-in flex items-center gap-3 rounded-xl bg-violet-lighter px-4 py-2.5 text-sm text-violet-darker', className)}>
      <span className={cn('flex-1', language === 'bn' && 'font-bn')}>{mode === 'save' ? t.reviewBanner : t.reviewBannerTheme}</span>
      {onDiscard && (
        <Button variant="ghost" size="sm" onClick={onDiscard} className="gap-1 text-violet-darker">
          <X /> {t.discard}
        </Button>
      )}
    </div>
  )
}
